<style scoped lang="scss">
.box {
  width: 100%;
  box-sizing: border-box;
  background: #f2f2f2;
  padding: 20px 20px 20px 50px;

  .page_title {
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-left: 10px solid #3399ff;
    font-size: 16px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
    color: #666666;
    font-weight: 700;
    padding-left: 15px;
  }
}
</style>
<template>
  <div
      class="box"
      element-loading-text="正在查询,请稍候..."
  >
    <p class="page_title">车辆黑名单管理</p>
    <div class="query_box">
      <el-form :model="form" ref="form" label-position="100px" size="medium">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-input
                v-model="form.carNo"
                size="medium"
                placeholder="请输入车牌号"
            ></el-input>
          </el-col>
          <el-col :span="5">
            <el-input
                v-model="form.owner"
                size="medium"
                placeholder="请输入车主姓名"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <el-button size="medium" type="primary" icon="el-icon-search" @click="qryinfo()">查询</el-button>
            <el-button size="medium" icon="el-icon-refresh" @click="qryinfo(true)">重置</el-button>
          </el-col>
          <el-col :span="8" style="text-align: right">
            <el-button size="medium" type="primary" icon="el-icon-plus" @click="addVisible = true"
            >新增
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table_box">
      <data-table :columns="tableColumns" :data="tableData" @selects="selects">
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete" @click="del(scope.$index, scope.row)">解锁</el-button>
            <el-button @click="handleClick2(scope.row)"
                       type="primary"
                       icon="el-icon-search">查看违章
            </el-button>
          </template>
        </el-table-column>
      </data-table>
      <Pagination :page.sync="page" @pageChange="this.qryinfo"/>
      <el-dialog
          title="违章记录"
          :visible.sync="dialogVisible"
          width="60%">
        <el-table
            :data="tableData2"
            style="width: 100%"
            :row-class-name="tableRowClassName">
          <el-table-column
              prop="carOwner"
              label="车主"
              width="300">
          </el-table-column>
          <el-table-column
              prop="carNo"
              label="车牌号"
              width="300">
          </el-table-column>
          <el-table-column
              prop="createTime"
              label="超速时间">
          </el-table-column>
<!--          <el-table-column-->
<!--              prop="originalScore"-->
<!--              label="原有积分">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              prop="surplusScore"-->
<!--              label="剩余积分">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              prop="score"-->
<!--              label="本次扣分">-->
<!--          </el-table-column>-->
        </el-table>
        <Pagination :page.sync="page"/>
      </el-dialog>
      <the-add :visible.sync="addVisible" @success="operationSuccess"></the-add>
      <edit
          :editForm="selectedData"
          :visible.sync="editVisible"
          @success="operationSuccess"></edit>
    </div>
  </div>
</template>

<script>
import index from "@/components/mixins/index";
import DataTable from "@/components/common/DataTable.vue";
import TheAdd from "./TheAdd.vue"
import Edit from "./Edit.vue";
import {findBlackCar, delBlackCar, getBlackType} from "./api/index"
import {findCarByCarOn} from "../speedManage/api";

export default {
  mixins: [index],
  data() {
    return {
      form: {},
      page: {
        pageNum: 1,
        pageSize: 8,
        total: 0,
      },
      options: [],
      value: "",
      selectedData: {},
      tableColumns: [
        {label: "车牌号", prop: "carNo", minWidth: "60", sort: true},
        {label: "车主姓名", prop: "carOwner", minWidth: "60"},
        {label: "手机号", prop: "phone", minWidth: "60"},
        {label: "黑名单类型", prop: "blackType", minWidth: "60"},
        {label: "添加时间", prop: "createTime", minWidth: "60"},
      ],
      tableData: [],
      addVisible: false,
      editVisible: false,
      dialogVisible: false,
    };
  },
  methods: {
    handleClick2(row) {
      this.dialogVisible = true;
      this.findCar = row;
      let data = {};
      data.current = this.page.pageNum;
      data.size = this.page.pageSize;
      findCarByCarOn(row.carNo, data).then(res => {
        this.tableData2 = res.data.data.records;
        this.page.total = res.data.data.total;
      });
    },
    handleClick(index, row) {
      this.selectedData = Object.assign({}, row);
      this.editVisible = true;
    },
    qryinfo(reset) {
      if (reset) {
          this.form.carNo = null
          this.form.owner = null
      }
      let data = Object.assign({}, this.form);
      data.current = this.page.pageNum;
      data.size = this.page.pageSize;

      findBlackCar(data)
          .then((res) => {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
          });
    },
    operationSuccess() {
      this.addVisible = false;
      this.editVisible = false;
      this.qryinfo();
    },
    del(index, row) {
      this.$confirm('此操作将解锁黑名单车辆, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let id = row.id;
        delBlackCar(row.id)
            .then((res) => {
              this.qryinfo();
            })
            .catch((err) => {
              this.loading = false;
              this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
                type: "error",
              })
            });
      })
    },
    getBlackType() {
      getBlackType('1011')
          .then((res) => {
            this.options = res.data.data;
          })
    },
  },
  components: {
    DataTable,
    TheAdd,
    Edit
  },
  mounted() {
    this.qryinfo();
    this.getBlackType();
  }
};
</script>

